import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const ovarianCyst: AnswerPathTreeNode = {
  path: 'ovarianCyst',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredOvarianCystDetails }],
};
